export enum DipRegistrationTaggingUrls {
    TEST = 'https://nexus.ensighten.com/tdb/tdimyins-privacy-dev/Bootstrap.js',
    PROD = 'ttps://nexus.ensighten.com/tdb/tdimyins-privacy-prod/Bootstrap.js'
}
